import { Injectable, Inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { StorageService } from 'src/app/core/services/storage.service';
import { RootScopeService } from 'src/app/core/services/root-scope.service';
import { LaunchDarklyService } from 'src/app/core/services/launch-darkly.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private storageService: StorageService,
    private rootScope: RootScopeService,
    @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth,
    private ldService: LaunchDarklyService
  ) {}

  async loginWithOkta() {
    // Clear and set credentials if needed
    this.clearCredentials();
    await this.setCredentials();
    await this._oktaAuth.signInWithRedirect();
  }

  async logoutWithOkta() {
    // Clear app-side credentials immediately.
    this.clearCredentials();

    // Clear local tokens before starting logout.
    await this._oktaAuth.tokenManager.clear();

    try {
      //  close Okta session and immediately request
      // an interactive login, returning to app home after auth.
      await this._oktaAuth.closeSession();
      await this._oktaAuth.signInWithRedirect({
        prompt: 'login',
        maxAge: 0,
        originalUri: '/home',
      });
      return;
    } catch {
      // Fallback: guaranteed Okta logout without post_logout_redirect_uri.
      // This avoids 400 errors in environments where redirect URIs are not registered.
      await this._oktaAuth.signOut({
        postLogoutRedirectUri: null,
        clearTokensBeforeRedirect: true,
      });
    }
  }

  clearCredentials() {
    this.rootScope.globals = {};
    this.storageService.destroySession('globals');
  }

  async setCredentials() {
    let user = await this._oktaAuth.getUser();
    this.rootScope.globals.currentUserId = user.preferred_username?.toLowerCase();
    this.rootScope.globals.currentUserName = user.given_name + ' ' + user.family_name;
    this.rootScope.globals.currentUserEmail = user.email;
    this.storageService.setSession('globals', this.rootScope.globals);
    // Re-identify LaunchDarkly with the real user now that credentials are available
    this.ldService.identifyWithCurrentUser();
  }
}